import styled from 'styled-components'

interface Props {
    active: boolean
}

interface DropDownAlign {
    last?: boolean
}

export const ConfigHeaderFilterContainer = styled.div<Props>`
    display: flex;
    align-items: center;
    height: 100%;
    /* justify-content: flex-end; */
    position: relative;

    .configheaderfilter-clickable {
        padding: 2px 16px 0px;
        height: 32px;
        min-width: 160px;
        text-transform: uppercase;
        font-size: 11px;
        border: none;
        font-weight: 600;
        color: ${({ theme }) => theme['gray-900']};
        display: flex;
        align-items: center;
        background-color: ${props =>
            props.active ? ({ theme }) => theme['gray-700'] : ({ theme }) => theme['gray-200']};
        color: ${props => (props.active ? ({ theme }) => theme['gray-0'] : ({ theme }) => theme['gray-800'])};
    }

    .configheaderfilter-clickable:hover {
        background-color: ${({ theme }) => theme['gray-700']};
        color: ${({ theme }) => theme['gray-0']};
        cursor: pointer;
    }

    .configheaderfilter-clickable i {
        margin-left: 4px;
        margin-top: -2px;
    }
`

export const ConfigHeaderFilterDropdown = styled.div<DropDownAlign>`
    background: ${({ theme }) => theme['gray-0']};
    position: absolute;
    top: calc(100%);
    display: flex;
    flex-direction: column;
    gap: 12px;
    right: ${props => props.last && '0'};
`

export const FilterContainer = styled.div`
    /* margin: -10px -18px -12px !important; */

    .searchFilter {
        display: flex;
        flex-direction: row;
        align-items: center;
        border: none;
        border: 1px solid;
        border-color: #ccc;
        padding-left: 16px;

        input {
            border: none;
            height: 32px;
            width: 160px;
            font-weight: 400;
        }
        button {
            height: 32px;
            width: 32px;
            border: none;
            border-left: 1px solid #ccc;
            background: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        button:hover {
            background: transparent;
            color: ${({ theme }) => theme['gray-800']};
        }
        button i {
            height: auto;
            margin: 0;
        }
    }

    .selection {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 12px 8px;
        border: 1px solid #ccc;
        border-top: none;

        .line {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding-left: 8px;
            padding-bottom: 8px;

            span {
                font-weight: 600;
                font-size: 11px;
                text-transform: initial;
            }

            button {
                background: transparent;
                border: none;
                padding: 0;
                font-size: 11px;
            }
        }
        .button {
            padding: 2px 5px 2px 8px;
            border: 1px solid;
            border-color: #ccc;
            border-radius: 3px;
            background: transparent;
            color: #606a80;
            text-transform: none;

            i {
                margin-left: 4px;
            }
        }
        .button {
            margin-left: 8px;
        }

        .btn-link {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #37a3ef;
            text-transform: capitalize;
            font-weight: 400;
        }

        .btn-link:hover {
            background: transparent;
            color: #37a3ef;
            text-decoration: none;
        }
    }
    /* ===== Scrollbar CSS ===== */
    /* Firefox */
    * {
        scrollbar-width: auto;
        scrollbar-color: #c2c2c2 #ffffff;
    }

    /* Chrome, Edge, and Safari */
    *::-webkit-scrollbar {
        width: 12px;
    }

    *::-webkit-scrollbar-track {
        background: #ffffff;
    }

    *::-webkit-scrollbar-thumb {
        background-color: #c2c2c2;
        border-radius: 10px;
        border: 3px solid #ffffff;
    }

    .listing {
        padding: 8px 0px;
        max-height: 200px;
        overflow: auto;
        border-left: 1px solid #ccc;
        .list {
            width: 100%;
            background: transparent;
            border: none;
            padding: 8px 16px 8px 16px;
            text-align: left;
            display: flex;

            .check {
                width: 16px;
                color: #37a3ef;
                margin-right: 10px;
            }
        }
    }
`
